module.exports = __webpack_public_path__ + "static/media/post-template-icon.07bea021.svg";